<template>
  <div class="screen-content">
    <el-transfer
      filterable
      :data="allDevices"
      v-model="allocated"
      :titles="['未分配的屏幕', '已分配的屏幕']"
      :button-texts="['从列表删除', '添加到列表']"
      @change="dataChange"
    >
    </el-transfer>
    <br />
    <el-button type="primary" @click="cancel">返回</el-button>
  </div>
</template>
<script>
import programApi from "@/api/message/programList"
export default {
  name: "sendprogram",
  props: {
    sendData: {
      type: Object
    },
  },
  data() {
    return {
      allDevices: [],
      allocated: []
    }
  },
  mounted() {
    console.log('this.sendData.id', this.sendData.id)
    this.getAllDevices(0)
    this.getAllDevices(this.sendData.id)
  },
  methods: {
    dataChange(value, direction, movedKeys) {
      if (direction === "right") { // 分配
        programApi.allowScreenAndGroupByProgramme(this.sendData.id, {
          type: 1,
          ids: movedKeys.toString()
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("分配成功")
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else { // 取消分配
        programApi.allowScreenAndGroupByProgramme(this.sendData.id, {
          type: 0,
          ids: movedKeys.toString()
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("取消分配成功")
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    getAllDevices(type) { // 获取所有屏幕
      programApi.getScreenAndGroupByProgramme(type).then((res) => {
        if (res.data.code === 1000) {
          for (const device of res.data.data) {
            this.allDevices.push({
              key: device.id,
              label: device.type==2?'[分组]'+device.name:device.name
            })
            if(type){
              this.allocated.push(device.id)
            }
          }
        }
      })
    },
    cancel() {
      this.$emit('closeMethod')
    }
  }
}
</script>